import script from "./childrenPage.vue?vue&type=script&setup=true&lang=js"
export * from "./childrenPage.vue?vue&type=script&setup=true&lang=js"

import "./childrenPage.vue?vue&type=style&index=0&id=68708955&lang=sass&scoped=true"

import exportComponent from "H:\\Environment_蓝宇\\Src\\GZXY\\GZEUA\\GZ_CQ_V2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68708955"]])

export default __exports__